const AccountCreationStep = () => {
  return (
    <div>
      <h2 className="text-xl md:text-2xl lg:text-3xl font-bold mb-6 md:mb-6">
        Step 1. JAX® 계정 생성 
        <span className="block mt-1 md:inline md:mt-0 md:ml-2 text-primary text-sm md:text-lg font-normal">
          (이미 계정이 있으면 생략가능합니다.)
        </span>
      </h2>
      
      <div className="text-center space-y-4 md:space-y-8">
        <div className="bg-muted/50 p-4 md:p-8 rounded-lg max-w-2xl mx-auto">
          <div className="mb-4 md:mb-6">
            <p className="text-sm md:text-lg mb-3 md:mb-4 leading-relaxed">
              아래 사이트를 방문하여 JAX® account 생성해주세요.
            </p>
            <div className="bg-white/50 p-3 rounded border break-words">
              <a 
                href="https://www.jax.org/newcustomerform" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-primary hover:underline text-sm md:text-xl font-medium"
              >
                https://www.jax.org/newcustomerform
              </a>
            </div>
          </div>
          
          <div className="flex items-center justify-center gap-2 text-muted-foreground">
            <svg className="w-4 h-4 md:w-6 md:h-6 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <a 
              href="/central_tg_jax_new_customer_guide.pdf" 
              download="central_tg_jax_new_customer_guide.pdf"
              className="text-primary hover:underline text-sm md:text-lg text-center leading-tight"
            >
              [ 계정생성 PDF 가이드 다운로드 ]
            </a>
          </div>
        </div>

        <div className="bg-amber-50 border border-amber-200 p-4 md:p-6 rounded-lg max-w-2xl mx-auto text-center">
          <div className="space-y-2 md:space-y-2">
            <p className="font-bold text-sm md:text-lg">
              계정(Account Number) <span className="text-destructive">발급까지 약 2~3일</span> 소요됩니다.
            </p>
            <p className="text-sm md:text-base leading-relaxed">
              발급이 완료되면 <span className="font-bold">Account Number가 이메일로</span> 전달됩니다.
            </p>
            <p className="text-destructive font-medium text-sm md:text-base">
              Step 2. 주문은 Account Number가 생성된 이후 가능합니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountCreationStep;